import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, TextField, Grid, Stack } from '@mui/material';
import CustomDataGrid from '../../../../../reusable-components/datagrid/CustomDataGrid';
import { MANAGE_ITEMS } from '../../../../../reusable-components/datagrid/orderGuidesColumns';

OrderGuideItemsBulkUpload.propTypes = {
  allProducts: PropTypes.array,
  facilities: PropTypes.array,
  categories: PropTypes.array,
  groups: PropTypes.array,
  setFormData: PropTypes.func
};

export default function OrderGuideItemsBulkUpload({ allProducts, categories, facilities, groups, setFormData }) {
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [selectedFacilities, setSelectedFacilities] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedItemIds, setSelectedItemIds] = useState([]);

  const defaultAutocompleteSettings = {
    multiple: true,
    fullWidth: true,
    disableCloseOnSelect: true,
    limitTags: 7,
    size: "small",
    sx: { '& span.MuiAutocomplete-tagSizeSmall ': { color: 'primary.main' } }
  };

  useEffect(() => {
    setFormData({
      facilities: selectedFacilities?.map(facility => facility.value),
      categoryId: selectedCategory?.value,
      productIds: selectedItemIds
    });
  }, [selectedFacilities, selectedCategory, selectedItemIds]);

  return <>
    <Stack sx={{ mt: 2 }} spacing={2}>
      <Autocomplete
        {...defaultAutocompleteSettings}
        value={selectedGroups}
        onChange={(event, newValue) => {
          if (newValue.some((option) => option.all)) {
            setSelectedGroups(groups);
            setSelectedFacilities(facilities);
            return;
          }
          setSelectedGroups(newValue);
          const newVals = newValue.map(v => v.value);
          setSelectedFacilities(facilities.filter(f => newVals.includes(f.extraValue)));
        }}
        options={[{ label: 'Select All...', all: true }, ...groups]}
        renderInput={(params) => <TextField {...params} label="Groups" autoComplete="off"/>}
      />
      <Autocomplete
        {...defaultAutocompleteSettings}
        value={selectedFacilities}
        onChange={(event, newValue) => setSelectedFacilities(newValue.some((option) => option.all) ? facilities : newValue)}
        options={[{ label: 'Select All...', all: true }, ...facilities]}
        renderInput={(params) => <TextField {...params} label="Facilities" autoComplete="off"/>}
      />
      <Autocomplete
        fullWidth
        size= "small"
        value={selectedCategory}
        options={categories}
        onChange={(event, newValue) => {
          setSelectedCategory(newValue);
          setFilteredProducts(newValue ? allProducts.filter((product) => newValue.value === product?.agoraCategory?.id && !product.deactivated) : []);
        }}
        renderInput={(params) => <TextField {...params} label="Category" autoComplete="off"/>}
      />    
    </Stack>

    <Grid item xs={12}>
      {selectedCategory && <CustomDataGrid
        gridId="admin-manage-order-guide-items"
        checkboxSelection
        keepNonExistentRowsSelected
        boxSX={{ height: 'calc(100vh - 260px)' }}
        data={filteredProducts}
        gridColumns={MANAGE_ITEMS}
        sort={[{ field: 'subcategory', sort: 'asc' }]}
        disableSelectionOnClick
        isModal
        isLoading={false}
        onRowSelectionModelChange={(selectedItemIds) => {
          setSelectedItemIds(selectedItemIds);
        }}
        getRowId={(row) => row.id}
      />}
    </Grid>
  </>;
}
